import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "remixicon/fonts/remixicon.css";
import "./assets/css/style.css";
import "react-toastify/dist/ReactToastify.css";

// ✅ Lazy imports
const Main = lazy(() => import("./components/Website/Pages/Main"));
const PrintVouchers = lazy(() => import("./components/Website/Pages/PrintVouchers"));
const HomeWork = lazy(() => import("./components/Website/Pages/HomeWork"));
const Results = lazy(() => import("./components/Website/Pages/Results"));
const FeeStructure = lazy(() => import("./components/Website/Pages/FeeStructure"));
const Introduction = lazy(() => import("./components/Website/Pages/Introduction"));
const Administration = lazy(() => import("./components/Website/Pages/Administration"));
const BoardOfGovernors = lazy(() => import("./components/Website/Pages/BoardOfGovernors"));
const Jobs = lazy(() => import("./components/Website/Pages/Jobs"));
const Faculty = lazy(() => import("./components/Website/Pages/Faculty"));
const PromotionPolicy = lazy(() => import("./components/Website/Pages/PromotionPolicy"));
const SchoolUniform = lazy(() => import("./components/Website/Pages/SchoolUniform"));
const Syllabus = lazy(() => import("./components/Website/Pages/Syllabus"));
const Home = lazy(() => import("./components/Website/Pages/Home"));
const Admissions = lazy(() => import("./components/Website/Pages/Admissions"));
const Library = lazy(() => import("./components/Website/Pages/Library"));
const StudentAgeCriteria = lazy(() => import("./components/Website/Pages/StudentAgeCriteria"));
const Prospectus = lazy(() => import("./components/Website/Pages/Prospectus"));
const ComputerLab = lazy(() => import("./components/Website/Pages/ComputerLab"));
const ScienceLaboratory = lazy(() => import("./components/Website/Pages/ScienceLaboratory"));
const Transport = lazy(() => import("./components/Website/Pages/Transport"));
const Mosque = lazy(() => import("./components/Website/Pages/Mosque"));
const Playgrounds = lazy(() => import("./components/Website/Pages/Playgrounds"));
const DateSheet = lazy(() => import("./components/Website/Pages/DateSheet"));
const Contact = lazy(() => import("./components/Website/Pages/Contact"));
const NewsDetail = lazy(() => import("./components/Website/Pages/NewsDetail"));
const NewsList = lazy(() => import("./components/Website/Pages/NewsList"));
const PrintChallan = lazy(() => import("./components/Website/Pages/PrintChallan"));
const EventDetail = lazy(() => import("./components/Website/Pages/EventDetail"));
const EventGallery = lazy(() => import("./components/Website/Pages/EventGallery"));
const PhotoDetail = lazy(() => import("./components/Website/Pages/PhotoDetail"));
const PhotoGallery = lazy(() => import("./components/Website/Pages/PhotoGallery"));
const Meritlist = lazy(() => import("./components/Website/Pages/Meritlist"));

// Admin
const AdminMain = lazy(() => import("./components/Admin/AdminMain"));
const Dashboard = lazy(() => import("./components/Admin/Dashboard"));
const Banners = lazy(() => import("./components/Admin/Banners"));
const Content = lazy(() => import("./components/Admin/ContentPage/Content"));
const AddContent = lazy(() => import("./components/Admin/ContentPage/AddContent"));
const EditContent = lazy(() => import("./components/Admin/ContentPage/EditContent"));
const Events = lazy(() => import("./components/Admin/Events/Events"));
const VoucherSetting = lazy(() => import("./components/Admin/VoucherSetting"));
const News = lazy(() => import("./components/Admin/News/News"));
const EditNews = lazy(() => import("./components/Admin/News/EditNews"));
const AddNews = lazy(() => import("./components/Admin/News/AddNews"));
const Photos = lazy(() => import("./components/Admin/Photos/Photos"));
const Login = lazy(() => import("./components/Admin/Login/Login"));
const AddEvents = lazy(() => import("./components/Admin/Events/AddEvents"));
const EditEvents = lazy(() => import("./components/Admin/Events/EditEvents"));
const EditPhotos = lazy(() => import("./components/Admin/Photos/EditPhotos"));
const AddPhotos = lazy(() => import("./components/Admin/Photos/AddPhotos"));
const ManageAdministration = lazy(() => import("./components/Admin/Administration/ManageAdministration"));
const EditAdministration = lazy(() => import("./components/Admin/Administration/EditAdministration"));
const AddAdministration = lazy(() => import("./components/Admin/Administration/AddAdministration"));
const ManageBOG = lazy(() => import("./components/Admin/BOG/ManageBOG"));
const EditBOG = lazy(() => import("./components/Admin/BOG/EditBOG"));
const AddBOG = lazy(() => import("./components/Admin/BOG/AddBOG"));
const ManageMessage = lazy(() => import("./components/Admin/Message/ManageMessage"));
const EditMessage = lazy(() => import("./components/Admin/Message/EditMessage"));
const AddMessage = lazy(() => import("./components/Admin/Message/AddMessage"));
const ChangePassword = lazy(() => import("./components/Admin/ChangePassword"));

function Index() {
  return (
    <BrowserRouter>
      {/* Suspense fallback can be a spinner or simple loader */}
      <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
        <Routes>
          <Route path="/PrintVouchers/PrintChallan" element={<PrintChallan />} />
          <Route path="/" element={<Main />}>
            <Route path="/" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Home/PrintVouchers" element={<PrintVouchers />} />
            <Route path="/Home/PrintVouchers/:id" element={<PrintVouchers />} />
            <Route path="/Home/HomeWork" element={<HomeWork />} />
            <Route path="/Home/FeeStructure" element={<FeeStructure />} />
            <Route path="/Home/Introduction" element={<Introduction />} />
            <Route path="/Home/Administration" element={<Administration />} />
            <Route path="/Home/BoardOfGovernors" element={<BoardOfGovernors />} />
            <Route path="/Home/Jobs" element={<Jobs />} />
            <Route path="/Home/Faculty" element={<Faculty />} />
            <Route path="/Home/Admissions" element={<Admissions />} />
            <Route path="/Home/Library" element={<Library />} />
            <Route path="/Home/PromotionPolicy" element={<PromotionPolicy />} />
            <Route path="/Home/StudentAgeCriteria" element={<StudentAgeCriteria />} />
            <Route path="/Home/Prospectus" element={<Prospectus />} />
            <Route path="/Home/SchoolUniform" element={<SchoolUniform />} />
            <Route path="/Home/Playgrounds" element={<Playgrounds />} />
            <Route path="/Home/ComputerLab" element={<ComputerLab />} />
            <Route path="/Home/Mosque" element={<Mosque />} />
            <Route path="/Home/Transport" element={<Transport />} />
            <Route path="/Home/ScienceLaboratory" element={<ScienceLaboratory />} />
            <Route path="/Home/Syllabus" element={<Syllabus />} />
            <Route path="/Home/Contact" element={<Contact />} />
            <Route path="/Home/NewsList" element={<NewsList />} />
            <Route path="/Home/Merit-list" element={<Meritlist />} />
            <Route path="/Home/NewsDetail/:id" element={<NewsDetail />} />
            <Route path="/Home/EventDetail/:id" element={<EventDetail />} />
            <Route path="/Home/PhotoDetail/:id" element={<PhotoDetail />} />
            <Route path="/Examination/DateSheet" element={<DateSheet />} />
            <Route path="/Examination/Results" element={<Results />} />
            <Route path="/Home/EventGallery" element={<EventGallery />} />
            <Route path="/Home/PhotoGallery" element={<PhotoGallery />} />
          </Route>

          <Route path="/web-admin/login" element={<Login />} />
          {/* <Route path="/web-admin/sign-up" element={<SignUp />} /> */}

          <Route path="/web-admin" element={<AdminMain />}>
            <Route path="/web-admin/change-password" element={<ChangePassword />} />
            <Route path="/web-admin/dashboard" element={<Dashboard />} />
            <Route path="/web-admin/banners" element={<Banners />} />
            <Route path="/web-admin/content" element={<Content />} />
            <Route path="/web-admin/add-Content" element={<AddContent />} />
            <Route path="/web-admin/edit-Content/:id" element={<EditContent />} />
            <Route path="/web-admin/voucher-setting" element={<VoucherSetting />} />
            <Route path="/web-admin/events" element={<Events />} />
            <Route path="/web-admin/edit-events/:id" element={<EditEvents />} />
            <Route path="/web-admin/add-events" element={<AddEvents />} />
            <Route path="/web-admin/news" element={<News />} />
            <Route path="/web-admin/news/:id" element={<EditNews />} />
            <Route path="/web-admin/add-news" element={<AddNews />} />
            <Route path="/web-admin/administration" element={<ManageAdministration />} />
            <Route path="/web-admin/administration/:id" element={<EditAdministration />} />
            <Route path="/web-admin/add-administration" element={<AddAdministration />} />
            <Route path="/web-admin/bog" element={<ManageBOG />} />
            <Route path="/web-admin/bog/:id" element={<EditBOG />} />
            <Route path="/web-admin/add-bog" element={<AddBOG />} />
            <Route path="/web-admin/message" element={<ManageMessage />} />
            <Route path="/web-admin/message/:id" element={<EditMessage />} />
            <Route path="/web-admin/add-message" element={<AddMessage />} />
            <Route path="/web-admin/photos" element={<Photos />} />
            <Route path="/web-admin/edit-photos/:id" element={<EditPhotos />} />
            <Route path="/web-admin/add-photos" element={<AddPhotos />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Index />);
